import React from 'react';
import { GeoJSON, Circle, Tooltip } from 'react-leaflet';

// Rendu lecture seule des dessins de carte (petite carte du dashboard, mode Viewer)
const DrawingsLayer = ({ drawings = [] }) => (
    <>
        {drawings.map(d => {
            const style = { color: d.color || '#ef4444', fillColor: d.color || '#ef4444', fillOpacity: 0.3, weight: 3 };
            if (d.kind === 'circle' && d.circle) {
                return (
                    <Circle key={d.id} center={[d.circle.lat, d.circle.lng]} radius={d.circle.radius} pathOptions={style}>
                        {d.label && <Tooltip permanent direction="center" className="drawing-label">{d.label}</Tooltip>}
                    </Circle>
                );
            }
            if (!d.geojson) return null;
            return (
                <GeoJSON key={`${d.id}-${d.updated_at || ''}`} data={d.geojson} style={style}>
                    {d.label && <Tooltip permanent direction="center" className="drawing-label">{d.label}</Tooltip>}
                </GeoJSON>
            );
        })}
    </>
);

export default DrawingsLayer;
